import React from 'react';

import { IconButton, Typography } from '@material-ui/core';
import { MdFirstPage, MdKeyboardArrowLeft } from 'react-icons/md';
import { MdKeyboardArrowRight, MdLastPage } from 'react-icons/md';

import { Tooltip } from 'components';

import styles from './Table.module.scss';

const TablePaginationActions = ({ count, page, rowsPerPage, onPageChange }) => {
  const from = Math.min(count, page * rowsPerPage + 1);
  const to = Math.min(count, (page + 1) * rowsPerPage);

  return (
    <div className={styles.footer}>
      <IconButton onClick={e => onPageChange(e, 0)} disabled={!page}>
        <Tooltip title="First page">
          <MdFirstPage />
        </Tooltip>
      </IconButton>

      <IconButton onClick={e => onPageChange(e, page - 1)} disabled={!page}>
        <Tooltip title="Previous page">
          <MdKeyboardArrowLeft />
        </Tooltip>
      </IconButton>

      <Typography variant="caption" className={styles.pageDisplay}>
        {`${from}-${to} of ${count}`}
      </Typography>

      <IconButton
        onClick={e => onPageChange(e, page + 1)}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
      >
        <Tooltip title="Next page">
          <MdKeyboardArrowRight />
        </Tooltip>
      </IconButton>

      <IconButton
        onClick={e => onPageChange(e, Math.max(0, Math.ceil(count / rowsPerPage) - 1))}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
      >
        <Tooltip title="Last page">
          <MdLastPage />
        </Tooltip>
      </IconButton>
    </div>
  );
};

export default TablePaginationActions;
